import { Component, computed, input } from '@angular/core';
import { Theme } from '../../../core/models/responses/theme';

const VARIANTS = ['primary', 'secondary', 'tertiary'] as const;
type ThemeCardVariant = (typeof VARIANTS)[number];

@Component({
  selector: 'app-theme-card',
  imports: [],
  templateUrl: './theme-card.html',
  styleUrl: './theme-card.scss',
})
export class ThemeCard {
  readonly theme = input.required<Theme>();

  protected readonly icon = computed(() => this.theme().icon ?? 'quiz');
  protected readonly label = computed(() => this.theme().name);
  protected readonly variant = computed<ThemeCardVariant>(() => {
    const id = this.theme().id;
    let hash = 0;
    for (let i = 0; i < id.length; i++) {
      hash = (hash + id.charCodeAt(i)) % VARIANTS.length;
    }
    return VARIANTS[hash];
  });
}
